import React from 'react';
import './FloatButton.style.css';

const Group = ({ children, style = {} }) => {
  return (
    <div className={`float_button_group`} style={{ ...style }}>
      {children}
    </div>
  );
};

const FloatButton = ({
  children,
  onClick = () => {},
  size = 52,
  style = {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <button
      className={`float_button float_button_default`}
      onClick={onClick}
      style={{ width: size, height: size, ...style }}
    >
      {children}
    </button>
  );
};

FloatButton.Group = Group;

export default FloatButton;
